const initialState = {
  tenantCategoryMapping: [],
  productCategories: []
};

const CategoryMappingReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_TENANT_CATEGORY':
      return {
        ...state,
        tenantCategoryMapping: action.payload
      };
    case 'GET_CATEGORIES':
      return {
        ...state,
        productCategories: action.payload
      };
    default:
      return state;
  }
};

export default CategoryMappingReducer;
